import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// On importe tes fichiers JSON
import translationFR from './traductions/fr.json';
import translationEN from './traductions/en.json';
import translationES from './traductions/es.json';

const resources = {
  fr: { translation: translationFR },
  en: { translation: translationEN },
  es: { translation: translationES }
};

i18n
  .use(LanguageDetector) // Détecte la langue du navigateur (ex: fr-FR)
  .use(initReactI18next) // Passe i18n à React
  .init({
    resources,
    fallbackLng: "en", // Si la langue du visiteur n'est pas trouvée, on met l'anglais
    interpolation: {
      escapeValue: false // React sécurise déjà contre les failles XSS
    }
  });

export default i18n;